/**
 * The event groups' names (design 30), code -> name, for the calendar's day pane: an event carries
 * its `groupCode` only. Read once per language, keyed on it, so a change of language asks again.
 * Empty while it loads or when it did not load - the pane then shows no group name at all.
 */
import { useCallback, useMemo } from 'react';
import { useTranslation } from '../../i18n';
import { useAsync } from '../cabinet/state';
import { useCalendarApi } from './api';

export function useGroupNames(): ReadonlyMap<string, string> {
  const { i18n } = useTranslation('calendar');
  const api = useCalendarApi();
  const read = useCallback((signal: AbortSignal) => api.listCalendarGroups(signal), [api]);
  const groups = useAsync(read, `calendar:group-names:${i18n.language}`);
  return useMemo(
    () => new Map((groups.data?.items ?? []).map((group) => [group.code, group.name])),
    [groups.data],
  );
}
